import type { JSX } from 'react'

import { Icon, IconNames, IconSizes } from 'atoms/Icon'
import { TextBox } from 'atoms/TextBox'
import { Colors, TextAligning, TextBoxTypes } from 'atoms/TextBox/TextBox.h'
import { FIXED_INDENTS } from 'vars/index'
import { PlayerGeoblockSC } from './PlayerGeoblock.styled'

export interface IPlayerGeoblockProps {
  smallPlayer?: boolean
  title: string
  isFullscreen?: boolean
}

export const PlayerGeoblock = ({
  smallPlayer = false,
  title,
  isFullscreen = false,
}: IPlayerGeoblockProps): JSX.Element => {
  const isSmallPlayer = smallPlayer && !isFullscreen

  const config = isSmallPlayer
    ? {
        color: Colors.TEXT_ICON_SECONDARY,
        font: TextBoxTypes.FontLgBold,
        gap: FIXED_INDENTS.INDENT_10,
      }
    : {
        color: Colors.TEXT_ICON_SECONDARY,
        font: TextBoxTypes.FontXlBold,
        gap: FIXED_INDENTS.INDENT_30,
      }

  const { color, font, gap } = config

  return (
    <PlayerGeoblockSC gap={gap} isSmallPlayer={isSmallPlayer}>
      <Icon
        name={IconNames.geoblock}
        color={color}
        size={isSmallPlayer ? IconSizes.smLarge : IconSizes.xLarge}
      />
      <TextBox
        title={title}
        color={color}
        font={font}
        alignment={TextAligning.Center}
        maxLines={2}
        horizontalPaddings={FIXED_INDENTS.INDENT_40}
      />
    </PlayerGeoblockSC>
  )
}
